import { render } from "./AffiliateCampaignEdit.vue?vue&type=template&id=d2402aa4&scoped=true&ts=true"
import script from "./AffiliateCampaignEdit.vue?vue&type=script&lang=ts"
export * from "./AffiliateCampaignEdit.vue?vue&type=script&lang=ts"

import "./AffiliateCampaignEdit.vue?vue&type=style&index=0&id=d2402aa4&scoped=true&lang=scss"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2402aa4"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QForm from 'quasar/src/components/form/QForm.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QCard,QCardActions,QBtn,QForm});
